export enum STATUS_ACTIONS {
  APPLICATION_SUBMITTED = 'application-submitted',
  DISCONTINUE_APPLICATION = 'discontinue-application',
  FAIL_UW = 'fail-uw',
  PASS_UW = 'pass-uw',
  ACCEPT_OFFER = 'accept-offer',
  REJECT_OFFER = 'reject-offer',
  FAIL_KYC = 'fail-kyc',
  PASS_KYC = 'pass-kyc',
  SIGN_CONTRACT = 'sign-contract',
  REJECT_CONTRACT = 'reject-contract',
  REQUEST_ADDITIONAL_INFO = 'request-additional-info',
  PROVIDE_INFO = 'provide-info',
  COMPLETE_KYC = 'complete-kyc',
}
